<template>
  <SeoPage page-key="realizzazioneApplicazioniMobileLocarno" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'RealizzazioneApplicazioniMobileLocarnoPage'
})
</script>

